// extracted by mini-css-extract-plugin
export default {"modal":"find-record_modal__73RoJ","modalContent":"find-record_modalContent__giAeM"};